
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import PalletizerBasics from '../pages/palletizer-basics/page';
import SelectionGuide from '../pages/selection-guide/page';
import DecisionCriteria from '../pages/decision-criteria/page';
import CaseStudies from '../pages/case-studies/page';
import ManufacturersProducts from '../pages/manufacturers-products/page';
import PeripheralSystems from '../pages/peripheral-systems/page';
import AlternativesComparison from '../pages/alternatives-comparison/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/palletizer-basics',
    element: <PalletizerBasics />
  },
  {
    path: '/selection-guide',
    element: <SelectionGuide />
  },
  {
    path: '/decision-criteria',
    element: <DecisionCriteria />
  },
  {
    path: '/case-studies',
    element: <CaseStudies />
  },
  {
    path: '/manufacturers-products',
    element: <ManufacturersProducts />
  },
  {
    path: '/peripheral-systems',
    element: <PeripheralSystems />
  },
  {
    path: '/alternatives-comparison',
    element: <AlternativesComparison />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
